module.exports = __webpack_public_path__ + "static/media/Coin_Icon@2x.8312b395.png";